export const heroStats = [
  { value: 20, suffix: '+', label: 'Projektov' },
  { value: 97, suffix: '%', label: 'Presnosť AI' },
  { value: 14, suffix: '', label: 'Dňové šprinty' },
  { value: 4, suffix: '', label: 'AI modality' },
]
